module.exports = __webpack_public_path__ + "static/media/faq.14066651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/faq.jpg
// module id = 359
// module chunks = 0